<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Share capital  - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <form name="Sharecapital" [formGroup]="SharecapitalFormgGroup">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">

            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Share capital</h5>-->
              <div class="mb-3">
                <p class="">Please enter notes on share capital.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
                <p>Please provide details of fixed asset investments. Please enter a description in the item field below and the corresponding value in the year field.</p>
                <p>
                  Please provide a breakdown of shareholding by share class in the item field, showing the number of shares, the class, the
                  nominal value, for example, '1000 Ordinary Shares of £1 each' and then the corresponding total value in the relevant year field.
                  You are allowed upto 5 entries of each share class.
                </p>
              </div>
            </div>
            <div class="col-12 mt-3">
              <div class="row">
                <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="">
                    <h6 class="mt-2 mb-0 fw-bolder font-size-16">Allotted, called-up and paid</h6>
                  </div>
                </div>
                <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 text-start text-sm-end">
                  <button type="button" class="btn themedefault p-1 ps-2 pe-2" (click)="AddNew()" [disabled]="disablecapital">+ Add New</button>
                </div>
              </div>
            </div>
            <div formArrayName="Wizardrows">
              <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-md-12">
                <div class="row">
                  <div class="table-responsive">
                    <table class="tableheading table dataTable table-bordered table-striped row-border table-hover pt-10" style="white-space:nowrap !important;">
                      <thead>
                        <tr>
                          <th>Item Description</th>
                          <th>Share Class</th>
                          <th>{{commonService.StartYear}}</th>
                          <th *ngIf="commonService.showControl==true">{{commonService.LastYear}}</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let items of wizardrowslist.controls;let Pointindex=index;" [formGroupName]="Pointindex">
                          <td>
                            <input class="form-control itemDescription caseSenstive" appNumberdirective type="text" maxlength="100" formControlName="DescriptionShareType" [ngClass]="{ 'is-invalid':(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[Pointindex].value['DescriptionShareType'] == ''))}" />
                            <span class="text-danger" *ngIf="(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[Pointindex].value['DescriptionShareType'] == ''))">Item Description is required</span>
                          </td>
                          <td>
                            <select class="form-select" formControlName="ShareClassName" [ngClass]="{ 'is-invalid':(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[Pointindex].value['ShareClassName'] == ''))}">
                              <!--<option value=""></option>-->
                              <option>Ordinary</option>
                              <option>Preference</option>
                            </select>
                            <span class="text-danger" *ngIf="(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[Pointindex].value['ShareClassName'] == ''))">Select a Share Class type</span>
                          </td>
                          <td>
                            <input class="form-control text-end AccountNumber" maxlength="11" appNumberdirective type="text" formControlName="ShareCapitalSharePremiumSubtotal" (change)="CalculationsGrid()" />
                            
                          </td>
                          <td *ngIf="commonService.showControl==true"><input class="form-control text-end AccountNumber" maxlength="11" appNumberdirective type="text" formControlName="ShareCapitalSharePremiumSubtotal_LY" (change)="CalculationsGrid()" /></td>
                          <td class="text-center">
                            <button class="btn  btn-sm p-1" (click)="DeleteRow(Pointindex)" title="Delete" [disabled]="disablecapital"><span class="fa fa-trash-can cantrash text-danger"></span></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row text-center mt-2" *ngIf="this.wizardrowslist?.length==0">
              <b class="mb-2">No records found</b>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12  mt-4 pe-0" *ngIf="this.wizardrowslist?.length > 0">
              <div class="d-flex row justify-content-between">
                <!--<div class="col-lg-3 col-xxl-4 col-xl-3 col-md-6 col-sm-6"></div>-->
                <div [ngClass]="commonService.showControl? 'col-lg-3 w-39 col-xl-2 col-md-2 col-sm-12 pb-2 text-lg-end text-start pe-0':'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-lg-end text-start'">
                  <label class="pt-2">Total</label>
                </div>
                <div [ngClass]="commonService.showControl? 'col-lg-3 w-23 col-xl-4 col-md-4 col-sm-12 pb-2 px-0':'col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'">
                  <div class="input-group">
                    <div class="input-group-text ">£</div>
                    <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="ShareCapitalSharePremiumSubtotal" />
                  </div>
                </div>
                <div class="col-lg-3 w-23 col-xl-4 col-md-4 col-sm-12 pb-2 px-0" *ngIf="commonService.showControl==true">
                  <div class="input-group">
                    <div class="input-group-text ">£</div>
                    <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="ShareCapitalSharePremiumSubtotal_LY" />
                  </div>
                </div>
                <div class="col-lg-3 w-8 col-xl-2 col-md-2 text-end">
                  <!--<button type="button" class="btn themedefault p-1 ps-2 pe-2" (click)="AddNew()">Add New</button>-->
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
              <label class="color-black">Please enter any additional information in the field below.</label>
              <div class="mb-3">
                <textarea class="form-control txt-area allowSpecialChars" rows="5" [appTooltip]="showBubbledata" appNumberdirective maxlength="4000" formControlName="ShareCapitalFreeøtextComment" [disabled]="disablecapital"></textarea>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
